import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer, Modal } from 'antd';
import isMobile from '../../utils/isMobile';
import { CloseIcon, LeftIcon, WalletType } from '../../constants';
import NightElfPlugin from '../elf/NightElfPlugin';
import DiscoverPlugin from '../discover/DiscoverPlugin';
import { useWebLoginContext } from '../../context';
export default function ConnectModal({ open, onClose, validWallets, design }) {
    const mobileFlag = isMobile();
    const { _api, version } = useWebLoginContext();
    const elfApi = _api.nigthElf;
    const discoverApi = _api.discover;
    if (mobileFlag) {
        return (_jsx(Drawer, { className: "aelf-web-conntect-drawer", title: _jsxs(_Fragment, { children: [_jsx("span", { className: "title", children: "Connect Wallet" }), _jsx("img", { src: CloseIcon, onClick: onClose })] }), getContainer: false, closeIcon: null, onClose: onClose, prefixCls: "portkey-ant-drawer", open: open, placement: 'bottom', children: _jsx("div", { className: "plugin-entry-wrapper", children: validWallets.map((wallet) => {
                    if (wallet === WalletType.elf) {
                        return _jsx(NightElfPlugin, { onClick: elfApi.login }, wallet);
                    }
                    else if (wallet === WalletType.discover) {
                        return (_jsx(DiscoverPlugin, { version: version, detectState: discoverApi.discoverDetected, onClick: discoverApi.login }, wallet));
                    }
                }) }) }));
    }
    else {
        return (_jsx(Modal, { title: _jsxs(_Fragment, { children: [_jsx("span", { className: "title", children: "Connect Wallet" }), design === 'Web2Design' ? (_jsx("img", { className: "close-icon", src: CloseIcon, onClick: onClose })) : (_jsx("img", { className: "left-icon", src: LeftIcon, onClick: onClose }))] }), getContainer: false, open: open, closable: false, footer: null, centered: true, className: "aelf-web-connect-modal", prefixCls: "portkey-ant-modal", width: 430, children: _jsx("div", { className: "plugin-entry-wrapper", children: validWallets.map((wallet) => {
                    if (wallet === WalletType.elf) {
                        return _jsx(NightElfPlugin, { onClick: elfApi.login }, wallet);
                    }
                    else if (wallet === WalletType.discover) {
                        return (_jsx(DiscoverPlugin, { version: version, detectState: discoverApi.discoverDetected, onClick: discoverApi.login }, wallet));
                    }
                }) }) }));
    }
}
